import Create from '../views/campaigns/Create.vue'
import Index from '../views/campaigns/Index.vue'
import Update from '../views/campaigns/Update.vue'

export default [
    {
        path: '/campaigns/create',
        name: 'campaigns/create',
        component: Create,
        meta: { title: 'Kampagne anlegen' }
    },
    {
        path: '/campaigns',
        name: 'campaigns',
        component: Index,
        meta: { title: 'Kampagnen' }
    },
    {
        path: '/campaigns/index',
        redirect: '/campaigns'
    },
    {
        path: '/campaigns/:id',
        name: 'campaigns/update',
        component: Update,
        meta: { title: 'Kampagne bearbeiten' }
    }

]
